/* eslint-disable camelcase */
import plx03_banner_coffee_on from 'assets/png/street/banner_coffee_on.png';
import plx03_banner_coffee from 'assets/png/street/banner_coffee.png';
import plx03_charge_station_on from 'assets/png/street/charge_station_on.png';
import plx03_charge_station from 'assets/png/street/charge_station.png';
import plx03_chimney_on from 'assets/png/street/chimney_on.png';
import plx03_chimney from 'assets/png/street/chimney.png';
import plx03_solar_panel from 'assets/png/street/solar_panel.png';
import plx03_solar_panel_on from 'assets/png/street/solar_panel_on.png';
import plx03_solar_water_heater_on from 'assets/png/street/solar_water_heater_on.png';
import plx03_solar_water_heater from 'assets/png/street/solar_water_heater.png';
import plx03_trash_can_on from 'assets/png/street/trash_can_on.png';
import plx03_trash_can from 'assets/png/street/trash_can.png';

import plx02_van from 'assets/png/street/02_van.png';
import plx02_van_on from 'assets/png/street/02_van_on.png';

import plx01_bush_bike from 'assets/png/street/01_bush_bike.png';
import plx01_street_light from 'assets/png/street/01_street_light.png';
import plx01_tree_middle from 'assets/png/street/01_tree_middle.png';


const content = {
  bannerCoffee: {
    title: 'Außenbeleuchtung',
    description: 'Mit beleuchteten Schildern und Hinweisen an Fassaden und Außenanlagen werden Sie von Kunden schon von weitem gesehen. Wer will das nicht? Leuchtreklame im Außenbereich muss Wind und Wetter trotzen und auch hinsichtlich UV- und Temperaturbeständigkeit speziell ausgestattet sein. Erfahren Sie, wie Sie mit LED-Technik die beste Fernwirkung erzielen. ',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/austausch_beleuchtung?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=austausch_beleuchtung',
    },
  },
  chargeStation: {
    title: 'Ladesäulen',
    description: 'Was sind Elektroautos ohne Strom? Mit der Installation einer eigenen Ladesäule zeigen Sie wie zukunftsorientiert Ihre Unternehmensphilosophie ist. Bald werden Ihre Kunden mit Elektrofahrzeugen vorfahren: Wie gut, wenn sie während ihres Einkaufs bei Ihnen auftanken können.',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/ladesaeulen?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=ladesaeulen',
    },
  },
  chimney: {
    title: 'Wärmerückgewinnung',
    description: 'Kälteerzeugung und Klimatisierung sind die größten Stromverbraucher im Food-Handel. Knapp die Hälfte der Stromkosten im Lebensmitteleinzelhandel fallen in diesen Bereichen an. Es geht viel effizienter: mit passgenauen Kühlmöbeln oder intelligenter Abwärmenutzung. Finden Sie heraus wie und klicken Sie sich durch unser Informationsangebot. ',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/verbundkaelteanlagen_waermerueckgewinnung?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=verbundkaelteanlagen_waermerueckgewinnung',
    },
  },
  photovoltaik: {
    title: 'PV Anlage',
    description: 'Lassen Sie die Sonne auf Ihr Dach! Mit Photovoltaik können Sie nicht nur Ihren eigenen Strom produzieren und damit Kosten sparen, sondern dabei auch noch Geld verdienen. Wir zeigen Ihnen wie das geht!',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/photovoltaik?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=photovoltaik',
    },
  },
  waterSolar: {
    title: 'Solarthermie',
    description: 'Im Gegensatz zu fossilen Brennstoffen ist Solarenergie praktisch in unbegrenztem Maße verfügbar – klimaneutral und kostenlos. Alles gute Gründe, um die Vorteile einer solaren Trinkwassererwärmung oder Heizungsunterstützung mal genauer unter die Lupe zu nehmen. ',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/solarthermie?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=solarthermie',
    },
  },
  trash: {
    title: 'Plastikmüll vermeiden',
    description: 'Energiesparen ist nur ein Baustein beim Klimaschutz. Deshalb engagiert sich die Klimaschutzoffensive auch in anderen Bereichen. Zum Beispiel bei dem Vorhaben, Plastiktüten zu reduzieren bzw. ganz abzuschaffen. Machen Sie mit und werden Sie ein „Ressourcenschoner“ oder „Müllvermeider“! Bei uns erhalten Sie Flyer, Poster und weiteres Infomaterial, mit dem Sie Ihren Einsatz bewerben können.',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/Kunststofftragetaschen?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=kunststofftragetaschen',
    },
  },
  van: {
    title: 'Logistik & E-Flotte',
    description: 'Lieferung per Elektroauto: Gerade in der Logistik und im Lieferverkehr müssen Fahrzeuge hohe Anforderungen erfüllen. Ob und wie E-Fahrzeuge auch in Ihrem Fuhrpark Sinn machen, erfahren Sie hier.',
    link: {
      title: 'Jetzt handeln!',
      url: 'https://www.hde-klimaschutzoffensive.de/de/logistik_flotte?pk_campaign=virtuelle-marktstrasse&pk_source=strasse&pk_content=logistik_flotte',
    },
  },
};

// ----------------- PARALLAX LEVEL 1 -----------------
const plx1 = {
  plx01_bush_bike: {
    baseSrc: plx01_bush_bike,
    height: 22.4,
    top: 77.6,
    left: 1.8,
    depth: 1,
    ignoreEvents: true,
  },
  plx01_street_light: {
    baseSrc: plx01_street_light,
    height: 97.2,
    top: 2.8,
    left: 81.6,
    depth: 1,
    ignoreEvents: true,
  },
  plx01_tree_middle: {
    baseSrc: plx01_tree_middle,
    height: 100,
    top: 0,
    left: 28.6,
    depth: 2,
    ignoreEvents: true,
  },
};

// ----------------- PARALLAX LEVEL 2 -----------------
const plx2 = {
  plx02_van: {
    baseSrc: plx02_van,
    activeSrc: plx02_van_on,
    height: 33.5,
    top: 59.2,
    left: 7.2,
    depth: 2,
    infopanel: {
      content: content.van,
      overlay: {
        x: 'right',
        y: 'top',
      },
      button: {
        top: -3.8,
        left: -1,
      },
    },
  },
};

// ----------------- PARALLAX LEVEL 3 -----------------
const plx3 = {
  plx03_banner_coffee: {
    baseSrc: plx03_banner_coffee,
    activeSrc: plx03_banner_coffee_on,
    height: 8.8,
    top: 36.7,
    left: 5.2,
    depth: 'auto',
    infopanel: {
      content: content.bannerCoffee,
      overlay: {
        x: 'right',
        y: 'top',
      },
      button: {
        top: 10,
        left: 92.5,
      },
    },
  },
  plx03_charge_station: {
    baseSrc: plx03_charge_station,
    activeSrc: plx03_charge_station_on,
    height: 24.4,
    top: 53.3,
    left: 94,
    depth: 'auto',
    infopanel: {
      content: content.chargeStation,
      overlay: {
        x: 'left',
        y: 'top',
      },
      button: {
        top: -5.1,
        left: 74,
      },
    },
  },
  plx03_chimney: {
    baseSrc: plx03_chimney,
    activeSrc: plx03_chimney_on,
    height: 27.2,
    top: 19.4,
    left: 55.12,
    depth: 'auto',
    infopanel: {
      content: content.chimney,
      overlay: {
        x: 'right',
        y: 'bottom',
      },
      button: {
        top: -5,
        left: 55.2,
      },
    },
  },
  plx03_solar_panel: {
    baseSrc: plx03_solar_panel,
    activeSrc: plx03_solar_panel_on,
    height: 11.3,
    top: 18.3,
    left: 32.8,
    depth: 'auto',
    infopanel: {
      content: content.photovoltaik,
      overlay: {
        x: 'right',
        y: 'bottom',
      },
      button: {
        top: -12,
        left: 83,
      },
    },
  },
  plx03_solar_water_heater: {
    baseSrc: plx03_solar_water_heater,
    activeSrc: plx03_solar_water_heater_on,
    height: 14.4,
    top: 14.07,
    left: 62.5,
    depth: 'auto',
    infopanel: {
      content: content.waterSolar,
      overlay: {
        x: 'left',
        y: 'bottom',
      },
      button: {
        top: -10,
        left: 12,
      },
    },
  },
  plx03_trash_can: {
    baseSrc: plx03_trash_can,
    activeSrc: plx03_trash_can_on,
    height: 17.5,
    top: 63.3,
    left: 76.3,
    depth: 'auto',
    infopanel: {
      content: content.trash,
      overlay: {
        x: 'right',
        y: 'top',
      },
      button: {
        top: -3,
        left: 88,
      },
    },
  },
};

export { plx1, plx2, plx3 };



// WEBPACK FOOTER //
// ./src/config/StreetConfig.js